(function (fox, $) {
	'use strict';

	var Promise = fox.Promise;

	function wrapChecker (checker) {
		return function () {
			var res = checker.apply(this, arguments);

			return res instanceof Promise && res || Promise.resolve(res);
		};
	}

	const getMaxDiscount = require('../../components/common/getMaxDiscount')(fox);

	fox.registerWidget('Menu_Main', {
		configure: function () {
			this.registerOptions('', {
				autoRender: true,
				template: 'app_menu',
				menuMoreTemplate: 'app_menu_more',
				'embed.container': '#main-menu-wrapper',
				disableMore: false,
				dontReuseSn: true,
				'templateOptions.maxDiscount': getMaxDiscount(),
				pattern: {
					home: {
						position: 10,
						title: 'Home',
						url: '/'
					},
					about: {
						position: 80,
						title: 'About me',
						url: '/about'
					},
					activity: {
						position: 20,
						title: 'Calendar',
						url: '/activity'
					},
					videos: {
						position: 30,
						title: 'Videos',
						url: '/videos'
					},
					photos: {
						position: 40,
						title: 'Photos',
						url: '/photosets'
					},
					liveshowChecker: {
						position: 50,
						title: 'Live shows',
						url: '/liveshow'
					},
					tipsChecker: {
						position: 70,
						title: 'Tip Me',
						url: '/tips'
					},
					wishList: {
						position: 100,
						title: 'Wish List',
						url: fox.getEnv('wishlistUrl'),
						target: '_blank',
						'checkers.wishList': {
							callback: function (menuItem, key) {
								var url = menuItem.url;

								if (url) {
									if (!/^https?:\/\//.test(url)) {
										url = 'http://' + url;

										if (menuItem.url !== url) {
											var node = this._getMenuItem(key);
											var link = node && node.querySelector('a');

											if (link) {
												link.setAttribute('href', url);
											}
										}

										menuItem.url = url;
									}
								}

								return !fox.isEmpty(url);
							}.bind(this)
						}
					},
					blogChecker: {
						position: 110,
						title: 'Blog',
						url: '/blog'
					},
					skypeMe: {
						position: 80,
						title: 'Skype me',
						target: '_blank',
						url: fox.getEnv('modelProps.skyprivateLink'),
						'checkers.skypeMe': {
							callback: function () {
								return fox.getEnv('modelProps.skyprivateLink') && !fox.getEnv('restrictNotStreamate');
							}
						}
					},
					callme: {
						position: 90,
						title: 'Call me',
						url: '/callme',
						'checkers.callme': {
							callback: function () {
								return !fox.isEmpty(fox.getEnv('modelProps.verifyProfile'));
							}
						}
					}
				},
				userAction: {
					login: {
						position: 0,
						title: 'Login',
						url: '/login'
					},
					join: {
						position: 10,
						title: 'Join me',
						url: '/join'
					}
				},
				limits: {
					minWidth: 768
				},
				enableResize: true,
				onResizeTimeout: 300
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this._checkers = {};
			this._moreMenu = {};
			this._menu = this.getOption('pattern');
			this._userAction = this.getOption('userAction');
			this._refsToNodes = {};

			this._registerCheckersFromOptions();

			if (this.getOption('enableResize')) {
				$(this.window).on('resize', {ctx: this}, this._onResize);
			}

			this.callParent('init', arguments);
		},

		activate: function () {
			if (this.getOption('enableResize')) {
				$(this.window).on('resize', {ctx: this}, this._onResize);
			}

			this.callParent('activate', arguments);
		},

		deactivate: function () {
			if (this.getOption('enableResize')) {
				$(this.window).off('resize', this._onResize);
			}

			this.callParent('deactivate', arguments);
		},

		/**
		 * [addChecker description]
		 * @param {string} menuAlias [description]
		 * @param {function} checker   [description]
		 * @param {boolean} _async
		 * @return {object} this
		 */
		addChecker: function (menuAlias, checker, _async) {
			if (!(menuAlias in this._checkers)) {
				this._checkers[menuAlias] = {};
			}

			if (_async === true) {
				if ('async' in this._checkers[menuAlias]) {
					this._checkers[menuAlias].async.push(wrapChecker(checker));
				} else {
					this._checkers[menuAlias].async = [wrapChecker(checker)];
				}
			} else {
				if ('sync' in this._checkers[menuAlias]) {
					this._checkers[menuAlias].sync.push(checker);
				} else {
					this._checkers[menuAlias].sync = [checker];
				}
			}

			this._menu[menuAlias].waiting = true;

			return this;
		},

		clearChecker: function (menuAlias, _async) {
			if (menuAlias in this._checkers) {
				if (_async === true) {
					if ('async' in this._checkers[menuAlias]) {
						this._checkers[menuAlias].async = [];
					}
				} else {
					if ('sync' in this._checkers[menuAlias]) {
						this._checkers[menuAlias].sync = [];
					}
				}
			}

			return this;
		},

		rendering: function () {
			this._runCheckers();

			var sorted = this._sortMenu(this._menu);

			this.setTemplateOptions('baseLinks', sorted);
			this.setTemplateOptions('userAction', this._userAction);

			this.callParent('rendering', arguments);

			this._renderLinks(sorted, this._getMenuItem.bind(this));

		},

		embedToDom: function () {
			var _this = this;

			this.callParent('embedToDom', arguments);

			this._rebuildMenu();

			this._getMenus().forEach(function (menu) {
				fox.getObjectKeys(menu).forEach(function (key) {
					if ('waiting' in menu[key]) {
						var item = _this._getMenuItem(key);

						item.style.opacity = 0.5;
					}
				});
			});

			this.runAsyncCheckers()
				.then(this._rebuildMenu.bind(this));
		},

		runAsyncCheckers: function () {
			return Promise.all(this._runCheckers(true));
		},

		addMenuItem: function (alias, data, refresh) {
			this._menu[alias] = data;

			return refresh && this.render();
		},

		_onResize: function (e) {
			var _this = e.data.ctx;

			clearTimeout(_this.resizeTimeout);
			_this.resizeTimeout = setTimeout(function () {
				if (this._getViewPortWidth() < this.getOption('limits.minWidth')) {
					this._reset();
				}

				this.render();
			}.bind(_this), _this.getOption('onResizeTimeout'));
		},

		_registerCheckersFromOptions: function () {
			fox.mapObject(this.getOption('pattern'), function (value, key) {
				var checkers = value.checkers;

				if (checkers) {
					delete value.checkers;

					fox.each(checkers, function (checker) {
						this.addChecker(key, checker.callback, checker.async);
					}, this);
				}
			}, this);
		},

		_reset: function () {
			this._menu = fox.merge({}, this._menu, this._moreMenu);
			this._moreMenu = {};
			this._refsToNodes = {};

			return this;
		},

		_renderLinks: function (menu, getItemContainer) {
			menu.forEach(function (item) {
				var key = item.alias;
				var container = getItemContainer(key);
				var templater;

				[
					item.template,
					'main_menu_item_' + key,
					'main_menu_item_default'
				].some(function (value, idx) {
					var exist = fox.checkTemplate(value);

					if (exist || (!fox.isEmpty(value) && idx === 0)) {
						if (fox._isNewfe) {
							templater = this.getTemplater(value);
						} else {
							templater = fox.Zen(value, [item]);
						}

						return true;
					}
				}, this);

				if (!fox._isNewfe) {
					return container.appendChild(templater);
				}

				return templater && container.appendChild(templater.setData(item).compile());
			}, this);
		},

		_rebuildMenu: function () {
			var _this = this;

			function getMenuWidth (menuKeys) {
				var moreItem = _this._getMenuItem('list-container');

				return menuKeys.reduce(function (prev, key) {
					var item = _this._getMenuItem(key);

					return $(item).is(':visible') ? prev + $(item).width() : prev;
				}, $(moreItem).width() + _this._getScrollWidth());
			}

			if (this.getOption('disableMore') || this._getViewPortWidth() < this.getOption('limits.minWidth')) {
				return this._moveToMoreLinks();
			}

			var moreLinksNode = this._getMenuItem('list-container');
			var container = this.rdom1('[fox-main-menu-container]');
			var cWidth = $(container).width();
			var menuKeys = this._sortMenu(this._menu).map(function (value) {
				return value.alias;
			});
			var maxLoopAmount = menuKeys.length;
			var moreMenuKeys = this._sortMenu(this._moreMenu).map(function (value) {
				return value.alias;
			});

			var menuWidth = getMenuWidth(menuKeys) + 10;

			if (menuWidth > cWidth) {
				while (menuWidth > cWidth && maxLoopAmount--) {
					var key = menuKeys.pop();
					var node = this._getMenuItem(key);
					var width = $(node).is(':visible') ? $(node).width() : 0;

					this._moreMenu[key] = fox.clone(this._menu[key]);

					delete this._menu[key];

					if (node.parentNode) {
						this._refsToNodes[key] = node.parentNode.removeChild(node);
					}

					menuWidth -= width;
				}
			} else {
				moreMenuKeys.some(function (key, idx, arr) {
					var insertedNode = container.insertBefore(this._refsToNodes[key], moreLinksNode);
					var menuWidth = getMenuWidth(menuKeys.concat(key));
					var itemWidth = $(insertedNode).width();
					var moreKeys = fox.getObjectKeys(this._moreMenu);

					function moveToMain (key) {
						this._menu[key] = fox.clone(this._moreMenu[key]);

						delete this._moreMenu[key];

						return true;
					}

					if (menuWidth < cWidth) {
						menuKeys.push(key);

						moveToMain.call(this, key);
					} else {
						if (this._getVisibleItemsAmount(this._moreMenu) === 1 &&
							itemWidth < $(moreLinksNode).width()) {
							return moveToMain.call(this, key);
						}

						container.removeChild(insertedNode);

						return true;
					}
				}, this);
			}

			this._moveToMoreLinks();
		},

		_getVisibleItemsAmount: function (menu) {
			return fox.getObjectKeys(menu).filter(function (key) {
				return menu[key].display !== 'none';
			}).length;
		},

		_moveToMoreLinks: function () {
			var sorted = this._sortMenu(this._moreMenu);
			var container = this._getMenuItem('list-container');
			var templateName = this.getOption('menuMoreTemplate');
			var fragment;

			if (this._getVisibleItemsAmount(this._moreMenu) === 0) {
				if (container.parentNode) container.parentNode.removeChild(container);

				return false;
			}

			var moreLinksNode = this.dom1('[fox-main-menu-more-list]');

			if (moreLinksNode) {
				container.removeChild(moreLinksNode);
			}

			if (fox._isNewfe) {
				fragment = this.getTemplater(templateName).setData({
					additionalLinks: sorted
				}).compile();
			} else {
				fragment = fox.Zen(templateName, [{additionalLinks: sorted}]);
			}

			this._renderLinks(sorted, function (key) {
				return fragment.querySelector('[fox-main-menu-list-item="' + key + '"]');
			}.bind(this));

			this.rwom1('@root #navi').addClickHandler(fragment, {
				draggable: !this.getOption('previewMode')
			});

			container.appendChild(fragment);
		},

		_getMenuItem: function (alias) {
			return this.dom1('[fox-main-menu-item="' + alias + '"]') ||
				this._refsToNodes[alias] ||
				document.createElement('div');
		},

		_sortMenu: function (menu) {
			return fox.getObjectKeys(menu).map(function (key) {
				return fox.merge({alias: key}, this._processAccess(menu[key]));
			}, this).sort(function (a, b) {
				return a.position > b.position ? 1 :
					a.position < b.position ? -1 :
					0;
			});
		},

		_runCheckers: function (_async) {
			var _this = this;

			function resolve (results, key) {
				var res = results.every(function (res) {
					return res === true;
				});

				_this._toggleMenuItem(key, res);

				return res;
			}

			return fox.getObjectKeys(this._checkers).map(function (key) {
				var checkers = _this._checkers[key][_async === true ? 'async' : 'sync'];
				var menuItem;

				_this._getMenus().some(function (menu) {
					if (key in menu) {
						menuItem = menu[key];

						return true;
					}
				});

				if (fox.isArray(checkers)) {
					if (_async === true) {
						return Promise.all(checkers.map(function (checker) {
							return checker(menuItem, key, _this);
						})).then(function (results) {
							return resolve(results, key);
						});
					} else {
						return resolve(checkers.map(function (checker) {
							return checker(menuItem, key, _this);
						}), key);
					}
				}

				return false;
			});
		},

		_toggleMenuItem: function (alias, show) {
			var item;
			var condition = this.getOption('hideOnLimit') &&
				this._getViewPortWidth() < this.getOption('limits.minWidth');

			if (condition) {
				show = false;
			}

			if (this.isEmbedded() || this.fragment) {
				item = this._getMenuItem(alias);

				item.style.display = show ? 'inherit' : 'none';

				if (show) item.style.opacity = 1;
				if (condition) return false;
			}

			this._getMenus().some(function (menu) {
				if (alias in menu) {
					menu[alias].display = show ? 'inherit' : 'none';
					
					if (show) delete menu[alias].waiting;

					return true;
				}
			}, this);
		},

		_getMenus: function () {
			return [this._menu, this._moreMenu];
		},

		_getViewPortWidth: function () {
			return window.innerWidth || document.documentElement.clientWidth;
		},

		_getScrollWidth: function () {
			var scrollDiv = document.createElement('div');

			document.body.appendChild(scrollDiv);

			$(scrollDiv).css({
				width: '100px',
				height: '100px',
				overflow: 'scroll',
				position: 'absolute',
				top: '-10000px'
			});

			var scrollWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;

			document.body.removeChild(scrollDiv);

			return scrollWidth;
		},

		_processAccess: function (menuItem) {
			var app = this.rwom1('@root');

			if ('access' in menuItem) {
				switch (true) {
					case menuItem.access === 'member' && fox.isEmpty(app.member):
					case menuItem.access === 'guest' && !fox.isEmpty(app.member):
						menuItem.display = 'none';
					break;
				}
			}

			return menuItem;
		}
	});
})(fox, fox.jQuery);


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/menu/main.es.js